import { HttpClient } from '../common/utilities/httpclient';
import { AuthService } from '../common/interfaces/AuthService';

export class ApiError extends Error {}

export class UnknownApiError extends ApiError {}

export class NotFoundApiError extends ApiError {}

export class CacheApiClient extends HttpClient {
    public constructor(authService: AuthService, baseUrl?: string | URL | undefined) {
        super(authService, baseUrl);
    }

    public async getCacheStatus(): Promise<number> {
        const url = new URL('api/v1/cache/persons', this.urlBase);
        const result = await this.httpGet<boolean>(url);
        return result.status;
    }
}
export interface PermissionsApiResponse {
    admin: boolean;
    participant: boolean;
    clientId: string;
    clientName: string;
    companyId: string;
    limitedClient0: boolean;
}

export class PermissionsApiClient extends HttpClient {
    public constructor(authService: AuthService, baseUrl?: string | URL | undefined) {
        super(authService, baseUrl);
    }

    public async getPermissions(): Promise<PermissionsApiResponse> {
        const url = 'paths-sls-api-v2/config/permissions';
        const response = await this.httpGet<PermissionsApiResponse>(url);
        return response.data;
    }

    public async getAllFeatureFlags(): Promise<Record<string, boolean>> {
        const url = 'api/v1/feature';
        const response = await this.httpGet<Record<string, boolean>>(url);
        return response.data;
    }
}
